import { baseUrl } from "../../helpers/constants";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "../../locale/de/translation.json";
import translationEN from "../../locale/en/translation.json";
import useWindowSize from "../../helpers/useWindowSize";
import { ILuebOption } from "../../Models/ILuebOption";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

// initialize i18next with catalog and language to use
i18n.use(LanguageDetector).init({
  resources,
});

export function SchraubfallOptions() {
  const windowSize = useWindowSize();
  const imageSize = windowSize.width > 500 ? 150 : 100;

  const schraubfallOptions: ILuebOption[] = [
    {
      key: "schraube",
      icon: `${baseUrl}/IMAGES/CONFIST/SCHRAUBFALL_SCHRAUBE.PNG`,
      text: i18n.t<string>("schraube"),
    },
    {
      key: "mutter",
      icon: `${baseUrl}/IMAGES/CONFIST/SCHRAUBFALL_MUTTER.PNG`,
      text: i18n.t<string>("mutter"),
    },
    {
      key: "holdndrive",
      icon: `${baseUrl}/IMAGES/CONFIST/SCHRAUBFALL_HOLD_DRIVE.PNG`,
      text: "Hold + Drive",
    },
    {
      key: "rohrleitung",
      icon: `${baseUrl}/IMAGES/CONFIST/SCHRAUBFALL_ROHRLEITUNG.PNG`,
      text: i18n.t<string>("ueberwurfmutter"),
    },
  ];

  return schraubfallOptions;
}
